module.exports = __webpack_public_path__ + "static/media/downMouse.58d72b79.svg";